import styled from 'styled-components';

const PANEL_WIDTH = 320;

interface PanelContainerProps {
  isOpen: boolean;
}

export const PanelContainer = styled.div<PanelContainerProps>`
  width: ${({ isOpen }) => (isOpen ? `${PANEL_WIDTH}px` : '0')};
  min-width: ${({ isOpen }) => (isOpen ? `${PANEL_WIDTH}px` : '0')};
  height: ${({ isOpen }) => (isOpen ? `100%` : '0')};
  background: ${({ theme }) => theme.colors.background};
  border-left: ${({ isOpen, theme }) =>
    isOpen ? `1px solid ${theme.colors.lightLineOutline}` : 'none'};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  transition:
    width 0.3s ease-in-out,
    min-width 0.3s ease-in-out;
`;

export const PanelListHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PanelContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PanelFooter = styled.div`
  padding: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.lightLineOutline};
`;

export const FormContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;
